export const siteConfig = {
  baseUrl: "https://my-website-9fg.pages.dev",
  name: "Leon Madara",
  defaultTitle: "Leon Madara - Full Stack AI Developer & Designer, Nairobi",
  defaultDescription:
    "Leon Madara is a Full Stack AI Developer & Designer based in Nairobi, Kenya. Building high-performance web products, AI integrations, and data-driven interfaces.",
  defaultImage: "https://my-website-9fg.pages.dev/images/og-default.png",
  defaultImageAlt:
    "Leon Madara portfolio preview with portrait and full stack AI developer positioning.",
  email: "leon.madara@outlook.com",
  social: {
    github: "https://github.com/leon-madara",
    linkedin: "https://www.linkedin.com/in/leon-madara/",
    twitter: "https://twitter.com/leon_madara"
  },
  twitterHandle: "@leon_madara"
};
